import {consoleLogger} from '@gongxigames/framework/core/fragments/ConsoleLogger';

/**
 * [module] : current state name
 */
export interface DebugStatesMap {
    [moduleName: string]: string;
}

export class StatedDebug {
    static readonly M: number = 77;

    protected _states: DebugStatesMap = {};

    constructor() {
        document.addEventListener('keydown', this.keyboardInput.bind(this));
    }

    public setModuleState(moduleName: string, stateName: string): void {
        this._states[moduleName] = stateName;
    }

    public drawModulesMap(): void {
        for (const key in this._states) {
            if (this._states.hasOwnProperty(key)) {
                consoleLogger.log('' + key + ' - ' + this._states[key]);
            }
        }
    }

    private keyboardInput(event: KeyboardEvent): void {
        if (event.keyCode === StatedDebug.M) {
            this.drawModulesMap();
        }
    }
}
